import { render, staticRenderFns } from "./ContactsMessengers.vue?vue&type=template&id=b8453174&scoped=true&"
import script from "./ContactsMessengers.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ContactsMessengers.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ContactsMessengers.vue?vue&type=style&index=0&id=b8453174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8453174",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8453174')) {
      api.createRecord('b8453174', component.options)
    } else {
      api.reload('b8453174', component.options)
    }
    module.hot.accept("./ContactsMessengers.vue?vue&type=template&id=b8453174&scoped=true&", function () {
      api.rerender('b8453174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/contacts/components/ContactsMessengers.vue"
export default component.exports